import React from 'react';
import { ArrowRight, Calendar, Location, Time } from '@carbon/icons-react';
import { formatShortDate, formatTime, getRelativeDayLabel } from './workDayUtils';

/**
 * NextShiftCard - "Naredna smena": kada je sledeća smena, u koje vreme i gde.
 */
const NextShiftCard = ({ nextShift, loading = false, onOpenDetails }) => {
  const hasNextShift =
    Boolean(nextShift) &&
    Boolean(nextShift.startTime || nextShift.endTime || nextShift.area);
  const dateLabel = formatShortDate(nextShift?.startTime);

  return (
    <section className="wdash-panel wdash-next">
      <div className="wdash-panel__head">
        <span className="wdash-panel__icon">
          <Calendar size={20} />
        </span>
        <h2 className="wdash-panel__title">Naredna smena</h2>
      </div>

      {loading ? (
        <div className="wdash-next__skeleton">
          <span style={{ width: '60%' }} />
          <span style={{ width: '40%' }} />
        </div>
      ) : !hasNextShift ? (
        <p className="wdash-next__empty">Nema zakazane naredne smene</p>
      ) : (
        <>
          <span className="wdash-next__label">
            {getRelativeDayLabel(nextShift.startTime)}
            {dateLabel ? `, ${dateLabel}` : ''}
          </span>

          {(nextShift.startTime || nextShift.endTime) && (
            <span className="wdash-next__row">
              <Time size={16} />
              {formatTime(nextShift.startTime)}–{formatTime(nextShift.endTime)}
            </span>
          )}

          {nextShift.area && (
            <span className="wdash-next__row">
              <Location size={16} />
              {nextShift.area}
            </span>
          )}

          {typeof onOpenDetails === 'function' && (
            <button type="button" className="wdash-next__link" onClick={onOpenDetails}>
              Detalji smene
              <ArrowRight size={16} />
            </button>
          )}
        </>
      )}
    </section>
  );
};

export default NextShiftCard;
